// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
import initSlideshows from './theme/slideshow';
import initHeaderScroll from './theme/header';
import initHeroTicker from './theme/heroTicker';
import initHeaderPlataforma from './theme/cuenta-header';
import initEditarPerfil from './theme/editar-perfil';
import initCategoriasCalendario from './theme/categorias-calendario';
import initDiaCalendario from './theme/dia-calendario';
import initComunidadDiscord from './theme/videosDiscordComunidad';
import initFiltroDiccionario from './theme/filtroDiccionario';
import initBloquesAcordiones from './theme/bloquesAcordiones';
import initClasesGrabadasAcciones from './theme/clasesGrabadasAcciones';
import initFiltroApuntes from './theme/filtroApuntes';
import initFiltroClasesGrabadas from './theme/filtroClasesGrabadas';
import initTopicAcciones from './theme/TopicAcciones';
import initGuardarApuntes from './theme/guardarApuntes';
import initBlogFiltros from './theme/blogFiltros';
import initContratoUsuario from './theme/contratoUsuario';
import initVideoIntroUsuario from './theme/videoIntroduccion';
import initVideoBootcamp from './theme/videoBootcamp';
import initQuizNivel from './theme/quizNivel';
import initSwfLessonsAccionata from './theme/swfLessons';
import initSwfTopicAccionata from './theme/swfTopic';


initSlideshows();
initHeaderScroll();
initHeroTicker();
initHeaderPlataforma();
initEditarPerfil();
initCategoriasCalendario();
initDiaCalendario();
initComunidadDiscord();
initFiltroDiccionario();
initBloquesAcordiones();
initClasesGrabadasAcciones();
initFiltroApuntes();
initFiltroClasesGrabadas();
initTopicAcciones();
initGuardarApuntes();
initBlogFiltros();
initContratoUsuario();
initVideoIntroUsuario();
initVideoBootcamp();
initQuizNivel();
initSwfLessonsAccionata();
initSwfTopicAccionata();
